module.exports = __webpack_public_path__ + "media/images/ticket/matome_warning_m-40ed4caf563b309727f11d25ef589937.png";